import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChildren
} from "@angular/core";
import { IgenomicsState } from "@ispm/core/interfaces/genomics-state.interface";
import { CoreActionCreatorService } from "@ispm/core/services/core-action-creator.service";
import { NavigationConfigService } from "@ispm/dashboard/navigation/services/navigationConfig.service";
import { CURRENT_ORDER_ACTIONS } from "@ispm/dashboard/test/constants/current-order.constants";
import { DiagnosticOrderService } from "@ispm/dashboard/test/services/diagnostic-order.service";
import { PollJobService } from "@ispm/dashboard/test/services/poll-job.service";
import { TestService } from "@ispm/dashboard/test/services/test.service";
import { SearchService } from "@ispm/shared/dynamic-form/services/search.service";
import { NotificationStoreHandler } from "@ispm/shared/notification/service/notification-store-handler";
import { FormDataSubstitutionService } from "@ispm/shared/services/form-data-substitution.service";
import { TestMetaDataStoreHandler } from "@ispm/shared/services/test-meta-data-store-handler";
import { UICustomizationService } from "@ispm/shared/services/ui-customization.service";
import { AuthenticationService } from "@ispm/user/services/authentication.service";
import { PatientInfoService } from "@ispm/user/services/patientInfo.service";
import { Store } from "@ngrx/store";
import _, {isEmpty } from "lodash";
import { OrganizationService } from "@ispm/migration/services/organization.service";
import { PatientService } from "@ispm-client/modules/patient/services/patient.service";
import { DatePipe } from "@angular/common";
import { ActivityService } from "@ispm/user/services/activity.service";
import { NotificationMessageService } from "@ispm/core/components/customise-notification/notifications-message.service";
import { Subject } from "rxjs";
import { take, takeUntil } from "rxjs/operators";
import { ActivityActions } from "@ispm/user/constants/activityActions";
import { ActivatedRoute, Router } from "@angular/router";
import {
  testViewBasePath, testViewPathologistPath,
  testViewWithPatientProfile
} from "@ispm/test/routes/test-view-state-names";
import { RouterManagerService } from "@ispm/core/services/router-manager.service";
import { EMRIntegrationBeacon } from "@ispm-client/modules/pathways";

@Component({
  selector: 'gen-new-order',
  templateUrl: './new-order.component.html',
  styleUrls: ['new-order.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewOrderComponent implements OnInit, OnDestroy, AfterViewInit {
  public genderText: string;
  public showSearch: boolean;
  public validate: boolean;
  public isSubmitted: boolean;
  public tempWorkflowRequest: any;
  public disableSelectTest: boolean = false;
  public shouldShowNotes: boolean;
  public isEmbedded: any;
  public testNumberValue: string = '';
  public testNumberPlaceholder: string;
  public identifierFormula: boolean;
  public title: string;
  public hasEthnicity: boolean;
  public testNumberRegExp: RegExp;
  public managingFacilityUpdate: (event: any) => void;
  public formColumnLayout: boolean;
  public fitElementsInFullScreen: boolean;
  public showBatchId: boolean;
  public isRequestInProgress: boolean;
  public patientVal: any;
  public orgs: any;
  public formsConfig: any;
  public filteredPatients: any[];
  public dynamicInstitute: any;
  public specimenConfig: any;
  public analyses: any;
  public hideSpecimenInOrderFrom: any;
  public blurb: any;
  public diagnosticOrder: any;
  public availableOrganizations: any;
  public testInfoCollections: any;
  public flexWidth: boolean;
  public orgName: any;
  public patientCheck: boolean;
  public information: any;
  public currentOrgName: any;
  public managingFacilityConfig: {
    widgetPayload: {
      type: string;
      label: string;
      required: boolean;
      attributes: {
        '[appendTo]': string;
        '[forceFormMode]': boolean;
        '[forceSelection]': boolean;
      };
      placeholder: string;
    };
  };
  public updateFieldObject: { name: string; value: string; type: 'update' | 'init'; searchInQuery: boolean; };

  private _destroyed$: Subject<void> = new Subject<void>();
  private batchIdFormat: RegExp;
  private createsTreatmentPlan: boolean;
  private disableOrderValidation: boolean;
  private formValidation: number = 0;
  private hidePatient: any;
  private hideTestNumberAndType: any;
  private navigationParams: any;
  private patients: any[];
  private runningMode: any;
  private testHeaderElements: any;
  private testNumberIsInvalid: boolean = false;
  private validateSpecimen: boolean;

  @ViewChildren('specimenTypeReference') specimenTypeReference: QueryList<any>;
  @ViewChildren('dynamicFormReference') dynamicFormReference: QueryList<any>;

  constructor(
    private authService: AuthenticationService,
    private testService: TestService,
    private diagnosticOrderService: DiagnosticOrderService,
    private coreActionCreatorService: CoreActionCreatorService,
    private orgService: OrganizationService,
    private searchService: SearchService,
    private patientInfoService: PatientInfoService,
    private patientService: PatientService,
    private notificationMessageService: NotificationMessageService,
    private notificationStoreHandler: NotificationStoreHandler,
    private _changeDetector: ChangeDetectorRef,
    private navigationConfigService: NavigationConfigService,
    private pollJobService: PollJobService,
    private uICustomizationService: UICustomizationService,
    private formDataSubstitutionService: FormDataSubstitutionService,
    private testMetaDataStoreHandler: TestMetaDataStoreHandler,
    private store: Store<IgenomicsState>,
    private activityService: ActivityService,
    private datePipe: DatePipe,
    private activatedRoute: ActivatedRoute,
    private routerManagerService: RouterManagerService,
    private router: Router
  ) {
  }

  public ngOnInit() {
    this.analyses = this.activatedRoute.snapshot.data['testTypes'].body;
    this.patientVal = this.activatedRoute.snapshot.data['patient'];
    this.orgs = this.activatedRoute.snapshot.data['orgs'];
    this.tempWorkflowRequest = { };
    this.testNumberPlaceholder = 'Enter Test Number';
    this.identifierFormula = false;
    this.testNumberRegExp = /^([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])?[._-])*([A-Za-z0-9]+)$/;
    this.batchIdFormat = /[\s!@#$%^&*()+=\[\]{};':"\\|,.<>\/?]/;
    this.createsTreatmentPlan = false;
    this.title = 'New Test Request';
    this.managingFacilityConfig = {
      widgetPayload: {
        type: 'dropdown',
        label: 'Managing facility',
        required: true,
        attributes: {
          '[appendTo]': 'body',
          '[forceFormMode]': true,
          '[forceSelection]': false
        },
        placeholder: 'Select facility'
      }
    };
    const isEmbedded$ = this.coreActionCreatorService.isEmbedded();

    if (isEmbedded$ && typeof isEmbedded$.subscribe === 'function') {
      isEmbedded$
        .pipe(take(1))
        .subscribe(isEmbedded => this.isEmbedded = isEmbedded);
    }

    if (_.isEmpty(this.diagnosticOrderService.Draft)) {
      this.diagnosticOrder = {
        subject: this.patientVal?.id,
        orderer: '',
        performer: this.authService.user.info.id,
        role: this.authService.user.role,
        priority: 'routine',
        recipients: [],
        reason: [],
        specimen: [],
        organization: this.patientVal && this.patientVal.managingOrganization ? this.patientVal.managingOrganization : this.authService.user.organization,
        managingOrganization: this.calculateManagingOrganization(),
        dateOfTest: this.setClientTMZOrderDate(),
        identifiers: []
      };
      if (this.patientVal && this.patientVal.managingOrganization && this.patientVal.managingOrganization !== this.authService.user.organization) {
        this.diagnosticOrder.orderOnBehalf = this.patientVal.managingOrganization;
        this.searchService.organization = this.diagnosticOrder.orderOnBehalf;
        if (!this.orgService.organizations[this.patientVal.managingOrganization]) {
          this.orgService.organizations[this.patientVal.managingOrganization] = {
            name: this.patientVal.identifier[0].assigner.display,
            id: this.patientVal.managingOrganization
          };
        }
      }
    } else {
      Object.assign(this.diagnosticOrder, this.diagnosticOrderService.Draft);
      this.diagnosticOrder.subject = this.patientVal?.id;
      this.diagnosticOrderService.Draft = { };
    }

    this.managingFacilityUpdate = function (event) {
      this.diagnosticOrder.managingFacility = event;
    };
    this.runningMode = undefined;
    this.genderText = 'Gender';
    this.hasEthnicity = true;
    this.diagnosticOrder.showDuplicatePatient = true;
    this.availableOrganizations = this.orgs || [{
      id: this.authService.user.organization,
      name: this.authService.user.managingOrganization
    }];

    this.orgName = this.authService.user.managingOrganization;
    this.patientCheck = !!this.patientVal;

    this.showSearch = this.patientVal?Object.keys(this.patientVal).length === 0:false;

    this.testMetaDataStoreHandler.getDisplayConfig()
      .pipe(take(1))
      .subscribe(data => {
        if (data) {
          this.testHeaderElements = data;
          if (!!this.testHeaderElements) {
            const genderDescr = this.testHeaderElements.find(item => item.id === 'gender');
            if (!!genderDescr) {
              this.genderText = this.testMetaDataStoreHandler.getValueByKey(genderDescr, 'fields[0].label.keys.staticValue', this.genderText);
            }
            this.hasEthnicity = !!this.testHeaderElements.find(item => item.id === 'ethnicity');
          }
        }
      });

    this.fitElementsInFullScreen = _.get(this.analyses[0], 'fitElementsInFullScreen', false);
    this.disableSelectTest = (this.analyses.length === 1);
    if (this.activatedRoute.snapshot.queryParams.testName) {
      this.tempWorkflowRequest = this.analyses.find(item => item.name === this.activatedRoute.snapshot.queryParams.testName);
      this.diagnosticOrder.workflowRequest = this.tempWorkflowRequest.id;
      this.disableSelectTest = true;
    }
    if (!this.diagnosticOrder.workflowRequest && this.analyses.length === 1) {
      this.tempWorkflowRequest = this.analyses[0];
      this.diagnosticOrder.workflowRequest = this.tempWorkflowRequest.id;
    }

    if (this.activatedRoute.snapshot.queryParams.testNumber) {
      if (!this.diagnosticOrder.identifiers) {
        this.diagnosticOrder.identifiers = [];
      }
      if (!this.diagnosticOrder.identifiers[0]) {
        this.diagnosticOrder.identifiers[0] = { };
      }

      this.testNumberValue = this.activatedRoute.snapshot.queryParams.testNumber;
      this.diagnosticOrder.identifiers[0].value = this.testNumberValue;
    } else {
      this.testNumberValue = '';
    }
    this.loadTestInfoCollectionsAndSpecimenInfo();
    this.getOrgName();
  }

  public ngAfterViewInit() {
    this.coreActionCreatorService.setLoader(false);
  }

  public ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  private allDynamicFormValid(): boolean {
    const specimenFormsAreInvalid = this.specimenTypeReference.some(s => s.specimenTypeForm.testSpecimenStatus === false);
    const dynamicFromsAreInvalid = this.dynamicFormReference.some(d => d.isDynamicFormValid() === false);

    return !specimenFormsAreInvalid && !dynamicFromsAreInvalid;
  }

  private calculateManagingOrganization() {

    if(this.patientVal && this.patientVal.identifier) {
      if (this.patientVal.identifier[0].assigner.display.toLowerCase() === this.authService.user.managingOrganization.toLowerCase()) {
        return this.authService.user.managingOrganization;
      } else {
        return  this.patientVal.managingOrganization;
      }
    }
    return this.authService.user.managingOrganization;

  }

  private loadTestInfoCollectionsAndSpecimenInfo() {
    if (!this.testService.testInfoCollections) {
      this.testService.loadTestInfoCollections().then(() => {
        this.testInfoCollections = this.testService.testInfoCollections;
        this.getSpecimenInfo();
      });
    } else {
      this.testInfoCollections = this.testService.testInfoCollections;
      this.getSpecimenInfo();
    }
  }

  public setWorkflowRequest = ($event) => {
    this.diagnosticOrder.workflowRequest = $event.id;
    this.getSpecimenInfo();
  }

  /*Create patient button click functionality starts */
  public createPatient() {
    let orgId, orgName;
    if (this.diagnosticOrder.orderOnBehalf) {
      const managingOrganization = this.availableOrganizations.find(org => org.id === this.diagnosticOrder.orderOnBehalf);
      orgName = managingOrganization.name;
      orgId = managingOrganization.id;
    } else if (this.diagnosticOrder) {
      orgName = this.diagnosticOrder['managingOrganization'];
      orgId = this.diagnosticOrder['organization'];
    }
    this.patientInfoService.openPatientInfo(null, orgId, orgName)
      .pipe(takeUntil( this._destroyed$))
      .subscribe((resp) => {
        if (resp.data === 1) {
          this.patientVal = resp.payload.patient;
          this.diagnosticOrder.subject = this.patientVal?.id;
          this._changeDetector.detectChanges();
        }
      });
  }

  /*Specimen Info method*/
  public getSpecimenInfo() {
    if (this.diagnosticOrder.workflowRequest) {

      if (!this.testService.testConfiguration || this.diagnosticOrder.workflowRequest !== this.testService.testConfiguration.id) {
        this.testService.getTestConfiguration(this.diagnosticOrder.workflowRequest).then(() => {
          this.handleSpecimenConfig();
          this.setCreatesTreatmentPlan();
        });
      } else {
        this.handleSpecimenConfig();
        if (this.testService.testConfiguration) {
          this.setCreatesTreatmentPlan();
        }
      }
    }
  }

  public handleSpecimenConfig() {
    this.hideSpecimenInOrderFrom = this.testService.testConfiguration.hideSpecimenInOrderFrom;
    this.disableOrderValidation = this.testService.testConfiguration.disableOrderValidation;
    this.validateSpecimen = typeof this.testService.testConfiguration.validateSpecimen !== 'undefined' ? this.testService.testConfiguration.validateSpecimen : true;
    this.validateSpecimen = this.validateSpecimen && !this.hideSpecimenInOrderFrom;
    this.showBatchId = this.testService.testConfiguration.showBatchId;
    this.formsConfig = this.testService.testConfiguration.formsConfig;
    this.information = this.testService.testConfiguration.information;

    if (typeof this.testService.testConfiguration.shouldShowNotes === 'boolean') {
      this.shouldShowNotes = this.testService.testConfiguration.shouldShowNotes;
    } else {
      this.shouldShowNotes = true;
    }

    this.blurb = this.testService.testConfiguration.orderBlurb;
    this.hidePatient = this.testService.testConfiguration.hidePatient;
    this.hideTestNumberAndType = this.testService.testConfiguration.hideTestNumberAndType;

    if (this.hidePatient) {
      if (this.patientVal) {
        this.patientVal.id = undefined;
      }
      this.diagnosticOrder.subject = undefined;
    }

    this.formColumnLayout = this.getFormColumnLayout(this.testService.testConfiguration.formColumnLayout);
    const disableDefaultForm = this.testService.testConfiguration.disableDefaultForm;
    this.checkIdentifierFormula();
    let defaultForm;
    if (!(this.formsConfig && this.formsConfig instanceof Array && (defaultForm = this.formsConfig.find(form => form.key === '')))) {
      this.formsConfig = this.formsConfig || [];
      defaultForm = { key: '', title: '', formId: 'BASIC-TEST-DATA-DEFAULT'};
      if (!disableDefaultForm) {
        this.formsConfig.unshift(defaultForm);
      }
    }
    this.updateFormsForRunningMode();
    this.prepareFormsData();
    this.diagnosticOrderService.formalizeForView(this.diagnosticOrder, defaultForm);
    this.triggerFormsValidation();
    this._changeDetector.detectChanges();

    // if oncologist create the new test make him the default ordering physician
    if (this.authService.user.role === 'Oncologist') {
      defaultForm.disabledFields = this.testService.testConfiguration.formRoleSettings
        && this.testService.testConfiguration.formRoleSettings.oncologist
        && this.testService.testConfiguration.formRoleSettings.oncologist.disabledFields || [];
      defaultForm.default = {
        ordererObject: {
          id: this.authService.user.info.id,
          text: this.authService.user.info.name[0].text
        },
        orderer: this.authService.user.info.id,
        orderingPractitioner: this.authService.user.info.name[0].text
      };
      Object.assign(this.diagnosticOrder, defaultForm.default);
      this._changeDetector.detectChanges();
    }

    this.dynamicInstitute = this.testService.testConfiguration.dynamicInstitute;

    if (this.diagnosticOrder.orderOnBehalf && this.diagnosticOrder.orderOnBehalf !== this.diagnosticOrder.organization) {
      this.diagnosticOrder.orderOnBehalf = this.diagnosticOrder.organization;
      this.orgChange();
    }

    this.specimenConfig = this.testService.testConfiguration.specimenConfig;
    this.flexWidth = !!this.testService.testConfiguration.FlexWidthOrder;

    if (this.hideSpecimenInOrderFrom) {
      this.specimenConfig = [];
    }

    this.setInitialDiagnosticOrder(this.specimenConfig);
  }

  public prepareFormsData() {
    this.formsConfig.forEach(formConfig => {
      if (!!formConfig['overrideInputs']) {
        this.formDataSubstitutionService.overrideData(this, formConfig.formId, formConfig.overrideInputs);
      }
    });
  }

  public updateFormsForRunningMode() {
    const runningModeData = this.testService.getRunningModeData(this.runningMode);
    if (!!runningModeData && !!runningModeData.defaultFormNeeded && runningModeData.defaultFormNeeded === true) {
      const runningModeForm = { key: '', title: '', formId: this.runningMode.toUpperCase() + '-MODE'};
      if (this.formsConfig && this.formsConfig instanceof Array) {
        this.formsConfig.unshift(runningModeForm);
      } else {
        this.formsConfig = [runningModeForm];
      }
      if (!runningModeData.useOverrideInputs) {
      }
    }
  }

  public getSpecimenTemplate(specimenConfig) {
    return specimenConfig.specimenTemplate ? specimenConfig.specimenTemplate : specimenConfig.specimenType;
  }

  public setCreatesTreatmentPlan() {
    this.createsTreatmentPlan = this.testService.testConfiguration ? this.testService.testConfiguration.createsTreatmentPlan : false;
    this.title = this.createsTreatmentPlan ? 'New Treatment Plan' : 'New Test Request';
  }

  public getFormColumnLayout = (formColumnLayout) => {
    return formColumnLayout === undefined ? true : formColumnLayout;
  }

  public checkIdentifierFormula() {
    if (this.testService.testConfiguration.identifierFormula) {
      this.identifierFormula = true;
      this.testNumberPlaceholder = 'Auto generated';
      delete this.diagnosticOrder.identifiers;
    } else {
      this.identifierFormula = false;
      this.testNumberPlaceholder = this.testService.testConfiguration.identifierPlaceHolder || 'Enter Test Number';
      if (!this.diagnosticOrder.identifiers) {
        this.diagnosticOrder.identifiers = [];
      } else {
        this.diagnosticOrder.identifiers[0].value = this.testNumberValue;
      }
    }
  }

  public triggerFormsValidation() {
    this.validate = true;
    const timeoutCounter = 500;
    setTimeout(() => this.validate = false, timeoutCounter);
  }

  public setInitialDiagnosticOrder(specimenConfig) {
    const specimenSet = new Set();
    this.diagnosticOrder.specimen = [];
    if (!!specimenConfig && !!this.testService.testInfoCollections && !!this.testService.testInfoCollections.specimenTypes &&
      Array.isArray(specimenConfig) && Array.isArray(this.testService.testInfoCollections.specimenTypes)) {
      specimenConfig.forEach(value => {
        const type = value.specimenType;
        if (specimenSet.has(type)) {
          this.diagnosticOrder.specimen.push({ });
        } else {
          specimenSet.add(type);
          this.diagnosticOrder.specimen.push({
            status: 'available',
            identifiers: []
          });
        }
      });
    }
    return;
  }

  public showPatientAndInstitute() {
    return this.diagnosticOrder.workflowRequest && !this.hidePatient;
  }

  public showTestNumberAndType() {
    return this.diagnosticOrder.workflowRequest ? (this.diagnosticOrder.workflowRequest && !this.hideTestNumberAndType) : true;
  }

  public showPatient() {
    return this.showSearch && this.showPatientAndInstitute();
  }

  public validationUpdate(valid, index) {
    const activeBits = Math.pow(2, index);

    if (!valid && this.formValidation > (this.formValidation ^ activeBits)) {
      this.formValidation ^= activeBits;
    } else if (valid) {
      this.formValidation |= activeBits;
    }
  }

  public updateForm(formUpdate, property) {
    if (!!property) {
      if (!this.diagnosticOrder[property]) { this.diagnosticOrder[property] = { }; }
      Object.assign(this.diagnosticOrder[property], formUpdate);

    } else {
      Object.assign(this.diagnosticOrder, formUpdate);
      if (formUpdate.ordererObject) {
        this.diagnosticOrder.orderer = formUpdate.ordererObject.id;
        this.diagnosticOrder.orderingPractitioner = formUpdate.ordererObject.text;
      }
    }
  }

  public orgChange(orgName?: any) {
    this.patientVal = null;
    let selectedOrganizationID = null;
    if (orgName) {
      const foundOrganization = this.availableOrganizations.find(org => org.name === orgName);
      selectedOrganizationID = foundOrganization?.id;
    }
    this.diagnosticOrder.orderOnBehalf = selectedOrganizationID;
    this.searchService.organization = this.diagnosticOrder.orderOnBehalf;
    this.diagnosticOrder.ordererObject = null;
    this.diagnosticOrder.orderer = null;
    this.diagnosticOrder.orderingPractitioner = null;
    this.diagnosticOrder.subject = null;
    this.updateFieldObject = {name: '', value: 'organization', type: 'init', searchInQuery: true};
  }

  public setClientTMZOrderDate() {
    const clientDate = new Date();
    return this.datePipe.transform(clientDate, 'dd MMM yyyy');
  }

  public search(str) {
    this.patients = [];
    const matched = '@@name=';
    const matchValue = str.query.split(' ').join(matched);
    this.patientService.getAllCustom(matchValue, 'id,name,birthDate,identifier,gender,demographics',
      this.diagnosticOrder.orderOnBehalf || this.diagnosticOrder.organization,
      'active=true'
    )
      .pipe(takeUntil( this._destroyed$))
      .subscribe((patients) => {
        this.patients = patients;
        this.filteredPatients = JSON.parse(JSON.stringify(this.patients));
        this._changeDetector.detectChanges();
      });
  }

  public selectPatient(selected) {
    this.patientVal = selected;
    this.diagnosticOrder.subject = this.patientVal?.id;
    this.filteredPatients = [];
    this.diagnosticOrder.showDuplicatePatient = true;
  }

  public submit() {
    this.isSubmitted = true;

    if ( this.allDynamicFormValid() && !this.testNumberIsInvalid && this.canSubmit(this.diagnosticOrder)) {
      // When changing the Institute field, the Test tags field is reset to NULL, then a 500 error is returned because to create a DiagnosticOrder, the value of the Test tags field should be [].
      if(this.diagnosticOrder.manualTags == null){
        this.diagnosticOrder.manualTags = [];
      }
      this.coreActionCreatorService.setLoader(true);
      this.updateOrganizationDataIfNeeded(this.diagnosticOrder);
      this.diagnosticOrder.showDuplicatePatient = false;
      this.isRequestInProgress = true;
      this.setOrderRunningMode();

      this.diagnosticOrderService.create(this.diagnosticOrder, this.validateSpecimen, this.disableOrderValidation)
        .pipe(takeUntil( this._destroyed$))
        .subscribe(
          (res) => {
            let revisionId = res.body.workflowRequest.revisions[res.body.workflowRequest.revisions.length - 1].id;
            this.store.dispatch({type: CURRENT_ORDER_ACTIONS.SET_IS_NEW_ORDER, payload: true});
            this.store.dispatch({type: CURRENT_ORDER_ACTIONS.SET_REVISION_ID, payload: revisionId});
            this.store.dispatch({type: CURRENT_ORDER_ACTIONS.SET_TEST_ID, payload: res.body.workflowRequest.id});
            this.store.dispatch({type: CURRENT_ORDER_ACTIONS.SET_PATIENT_ID, payload: res.body.subject});
            this.store.dispatch({type: CURRENT_ORDER_ACTIONS.SET_PATIENT, payload: this.patientVal});

            if (res.body.additionalData) {
              this.store.dispatch({
                type: CURRENT_ORDER_ACTIONS.SET_ALL_ORDERS,
                payload: res.body.additionalData.patientAnalysis
              });
              this.store.dispatch({
                type: CURRENT_ORDER_ACTIONS.SET_CURRENT_ORDER,
                payload: res.body.additionalData.patientAnalysisById
              });
              this.store.dispatch({
                type: CURRENT_ORDER_ACTIONS.SET_ORDERS_COUNT,
                payload: res.body.additionalData.ordersCount
              });
              this.store.dispatch({
                type: CURRENT_ORDER_ACTIONS.SET_WORKFLOW_DATA,
                payload: res.body.additionalData.workflowRequest
              });
              delete res.body.additionalData;
            }

            if (res.body.notes) {
              return this.diagnosticOrderService.createOrderNote(res.body)
                .pipe(takeUntil( this._destroyed$))
                .subscribe((note) => {
                  if (note) {
                    this.activityService.create({
                        actor: {
                          reference: note.body.actor.id,
                          resourceType: note.body.actor.resourceType
                        },
                        context: [{
                          reference: note.body.id,
                          resourceType: 'Note'
                        }],
                        action: ActivityActions.READ
                      })
                      .pipe(takeUntil( this._destroyed$))
                      .subscribe(() => {
                        this.handleOrderCreated(res.body);
                      });
                  }
                });
            } else {
              this.store.dispatch({ type: CURRENT_ORDER_ACTIONS.SET_SKIP_NOTES_FETCH, payload: true });
              this.handleOrderCreated(res.body);
            }
          },
          (err) => {
            this.coreActionCreatorService.setLoader(false);
            if (err.status == 400) {
              this.notificationMessageService.error(err.body);
            } else {
              this.notificationMessageService.error('error in creating order');
            }
          }
        );
      this.isRequestInProgress = false;
    }
  }

  public handleOrderCreated(createdOrder) {
    this.notificationMessageService.success('Item created successfully!');
    if (createdOrder.orderOnBehalf) {
      let item;
      this.router.navigate(['Pathologist']);
      this.navigationConfigService.getCurrentApp()
        .pipe(take(1))
        .subscribe(
          (app) => {
            this.navigationConfigService.getWebConfigurationByAppId(app.id)
              .pipe(take(1))
              .subscribe(
                (appConfiguration) => {
                  item = appConfiguration.find(item => item.headerTitle === 'Worklist');
                }
              );
          }
        );
      location.href = location.origin + item.redirectUrl;
    } else {
      const patientId = createdOrder.subject;
      const testId = createdOrder.workflowRequest.id;
      const revisionId = createdOrder.workflowRequest.revisions[createdOrder.workflowRequest.revisions.length - 1].id;
      let EMRIntegration = undefined;
      if (this.routerManagerService.queryParameters?.EMRIntegration === EMRIntegrationBeacon) {
        EMRIntegration = EMRIntegrationBeacon;
      }
      let navigateTo;
      this.navigationParams = {
        testId: testId,
        revisionId: revisionId
      };
      if (createdOrder.subject) {
        this.navigationParams.patientId = patientId;
        if (createdOrder.workflowRequest.name.contains('Pathway')) {
          navigateTo = testViewWithPatientProfile + '/' + this.navigationParams.patientId + '/' + this.navigationParams.testId + '/' + this.navigationParams.revisionId;
          if (EMRIntegration) {
            this.navigationParams.EMRIntegration = EMRIntegration;
          }
        } else {
          navigateTo = testViewPathologistPath + '/' + this.navigationParams.patientId + '/' + this.navigationParams.testId + '/' + this.navigationParams.revisionId;
        }
      } else {
        this.navigationParams.orderId = createdOrder.id;
        navigateTo = testViewBasePath + this.navigationParams.orderId + '/' + this.navigationParams.testId + '/' + this.navigationParams.revisionId;
      }
      this.pollJobService.pollingUntilStepAndNavigate(revisionId, testId, this.testService.testConfiguration, navigateTo, this.navigationParams);
    }
  }

  public setOrderRunningMode() {
    this.diagnosticOrder.runningMode = !!this.runningMode ? this.runningMode : this.diagnosticOrder.runningMode;
    const runningModeData = this.testService.getRunningModeData(this.runningMode);
    if (!!runningModeData) {
      if (this.diagnosticOrder.runningMode && this.diagnosticOrder.runningMode !== 'REGULAR') {
        this.diagnosticOrder = Object.assign(this.diagnosticOrder, runningModeData.orderData);
      } else {
        Object.keys(runningModeData).forEach((property) => {
          return _.unset(this.diagnosticOrder, property);
        });
      }
    }
    this.notificationStoreHandler.setNotification(this.testService.getNotifConfigurationByDiagnosticOrder(this.diagnosticOrder, this.testService.testConfiguration));
  }
  public updateOrganizationDataIfNeeded(diagnosticOrder) {
    if (this.testService.isNavicanControlSample() && diagnosticOrder.orderOnBehalf !== undefined) {
      // This test can be created only for user & patient organization
      diagnosticOrder.organization = this.authService.user.organization;
      diagnosticOrder.managingOrganization = this.authService.user.managingOrganization;
      diagnosticOrder.orderOnBehalf = undefined;
    }
  }

  public canSubmit(diagnosticOrder) {
    let valid = true;
    if (this.testService.testConfiguration.specimenConfig &&
      Array.isArray(this.testService.testConfiguration.specimenConfig) &&
      this.testService.testConfiguration.specimenConfig.length > 0 &&
      this.testService.testConfiguration.specimenConfig[0].accessionIdentifierFormat) {
      let identifierFormula = this.testService.testConfiguration.specimenConfig[0].accessionIdentifierFormat;
      if (identifierFormula && identifierFormula.length > 0) {
        diagnosticOrder.specimen.forEach((specimen) => {
          const prefix = identifierFormula[0].prefix ? identifierFormula[0].prefix : '';
          const suffix = identifierFormula[0].suffix ? specimen[identifierFormula[0].suffix] : '';
          // suffix exists and has no spaces
          if (suffix && suffix.length > 0 && !this.batchIdFormat.test(suffix)) {
            specimen.accessionIdentifier = {
              value: prefix + suffix
            };
            if (specimen.identifiers.length === 0) {
              specimen.identifiers.push(specimen.accessionIdentifier);
            }
            else {
              specimen.identifiers[0] = specimen.accessionIdentifier;
            }
          } else {
            valid = false;
          }
        });
      }
    }
    return valid;
  }

  public disableSubmitButton() {
    return this.isRequestInProgress || this.uICustomizationService.getUICustomResourceProperty('new-order-submit-button', 'disabled') ||
      (!(this.patientVal && this.patientVal.id) && !this.hidePatient);
  }

  public cancel() {
    window.history.back();
  }

  public checkIfDuplicate() {
    return this.diagnosticOrder.showDuplicatePatient ? this.diagnosticOrder.showDuplicatePatient : false;
  }

  public isAdmin(){
    return this.authService.isAdminUser(this.authService.user);
  }

  public getOrgName() {
    this.store.select('users', 'organizationConfiguration', 'name')
      .pipe(take(1))
      .subscribe(data => {
        this.currentOrgName = data;
      });
  }

  public OnTestNumberChange(event) {
    this.testNumberValue = event;
    if (!isEmpty(this.diagnosticOrder.identifiers)) {
      this.diagnosticOrder.identifiers[0].value = this.testNumberValue;

    }
  }

  public shouldShowTooltipForTestNumber(testNumberIsInValid): boolean {
    this.testNumberIsInvalid = !this.identifierFormula && testNumberIsInValid;
    return this.testNumberIsInvalid;
  }
}
